export enum IntakeActionEnum {
  RESET = 'Reset',
  DISCONTINUE = 'Discontinue',
  ADMIN_COMPLETE = 'Admin Complete'
}
